module.exports = __webpack_public_path__ + "static/media/galerija_2014 (38).88058268.jpg";